import { DefaultValues } from 'react-hook-form';
import { z } from 'zod';

import { authorSchema, identitySchema } from '@/core/components';

export const committeeSchema = z.object({
  title: z.string().min(3),
  year: z.number(),
  type: identitySchema.nullable(),
  authors: z.array(authorSchema),
});

export const defaultCommitteeValues: DefaultValues<CommitteeSchema> = {
  title: '',
  year: new Date().getFullYear(),
};

export type CommitteeSchema = z.infer<typeof committeeSchema>;
